import React, { FC, memo } from "react";

import BusinessWomanIcon from "../../assets/icons/icons8-businesswoman.svg";
import { SidebarItem } from "./sidebar_item";
import TagIcon from "../../assets/icons/icons8-pricing.svg";
import TruckIcon from "../../assets/icons/truck.svg";
import OverviewIcon from "../../assets/icons/drapes.svg";
import ProjectsIcon from "../../assets/icons/projects_icon.svg";
import styled from "../../theme";
import { LucidePackage } from "lucide-react";

export interface SidebarProps {
    /**
     * Expanded sidebar mode
     */
    // expanded: boolean;
    /**
     * Current active value
     */
    activeValue?: string;
    /**
     * Whether current account can access My Shop
     */
    canAccessMyShop?: boolean;
    /**
     * Navigation callback
     * @param to Navigation value
     */
    onNavigateTo(to: string): void;
}

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
    min-width: 65px;
    max-width: 65px;
`;

export const Sidebar: FC<SidebarProps> = memo((props) => (
    <Container>
        <SidebarItem
            // expanded={props.expanded}
            value="projects"
            active={props.activeValue === "projects"}
            label="Projects"
            icon={<ProjectsIcon width="1em" height="1em" />}
            onItemClick={props.onNavigateTo}
        />
        <SidebarItem
            // expanded={props.expanded}
            value="overview"
            active={props.activeValue === "overview"}
            label="Items"
            icon={<OverviewIcon width="1em" height="1em" />}
            onItemClick={props.onNavigateTo}
        />
        <SidebarItem
            // expanded={props.expanded}
            value="ordering-and-receiving"
            active={props.activeValue === "ordering-and-receiving"}
            label="Ordering & Receiving"
            icon={<LucidePackage className="lucide lucide-package w-6 h-6 mb-1" />}
            onItemClick={props.onNavigateTo}
        />
        <SidebarItem
            // expanded={props.expanded}
            value="clients"
            active={props.activeValue === "clients"}
            label="Clients"
            icon={<BusinessWomanIcon width="1em" height="1em" />}
            onItemClick={props.onNavigateTo}
        />
        {props.canAccessMyShop && (
            <SidebarItem
                // expanded={props.expanded}
                value="myshop"
                active={props.activeValue === "myshop"}
                label="My Shop"
                icon={<TagIcon width="1em" height="1em" />}
                onItemClick={props.onNavigateTo}
            />
        )}
        <SidebarItem
            // expanded={props.expanded}
            value="suppliers"
            active={props.activeValue === "suppliers"}
            label="Suppliers"
            icon={<TruckIcon width="1em" height="1em" />}
            onItemClick={props.onNavigateTo}
        />
    </Container>
));
